/**
 * Copyright (c) 2024, Mohamed eRrais
 * merrais@tech2us.ma
 * محمد الرايس
 * Rais Digital Services
 * 
 * moshaf.akademy.ma/apps
 * from tajwyd.akademy.ma
*/

import axios from 'axios';
import {base} from '../Config/app';

const token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJiaXNtaSI6Itio2ZDYs9uh2YXZkCDZsdmE2YTZh9mQINmx2YTYsdmR2Y7Yrduh2YXZjtmA2bDZhtmQINmx2YTYsdmR2Y7YrdmQ2YrZhdmQIiwiYWxhYW4iOiIxNCDYsdmF2LbYp9mGIDE0NDUiLCJpYXQiOjE3MTEzMzAyNDF9.m6pXkmbB6H0czA1E-7knprJ_lbo4AKB67MWe93024fY"

const Token = (app) => {
  const storage = localStorage.getItem(app)
  if(storage && JSON.parse(storage)?.token) {
    //alert(`${app}`)
    return JSON.parse(storage).token
  }
  else {
    return token
  }
}

const Api = axios.create({
  baseURL: base.api_url,  
  headers : {
    'Authorization': `Bridge ${Token(base.name)}`,   // Finaly MeR 260106 1218  Bearer -> Bridge    
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  },
  service : base.name
})


const Read = (request, Items, Load, Message) => {
  //alert(request)
  Items([])
  Api.get(request)
  .then(response => {
      //console.log('Moshaf.Get', request, response.data); alert('Moshaf.Load '+request)
      Items(response.data)
      Load && Load(true)
  })
  .catch(error => {
      //if (error.status && error.data)
      Message && Message(error)
      console.log('Error',request,error)
  })
}

const Update = (id, field, value, Message) => {

  if(id && id>0 && field && value) {
    let query=`/${id}/${field}/${value}`
    //alert(query)
    Api.put(query)
    .then(response => {
      let rows=response.data.affectedRows
      Message && Message(`${rows} updated`)
      //console.log('Moshaf.onUpdate', response.status, response.data.affectedRows)
    })
    .catch(error => {
      Message && Message(error)
      console.error(error)
    })
  }
}


async function Fetch(request, data, object=null, method='POST') {

	if(!request.startsWith('https'))    
		request = Api.defaults.baseURL+request
  
	return new Promise(function (resolve, reject) {
		//alert(`${request}`)
		fetch(request, {
			method: method,  
			headers: new Headers({
				'Authorization': Api.defaults.headers.Authorization,
				'Content-Type': "application/json"
			})
			,body: data && JSON.stringify(data) 
		}) 
		.then( async (response) => {
      //console.log("Response", request, method, data, response); alert(`Response ${response.status}`)
			if( [200,201,202].includes(response.status)) {
        if(object) {
				  object.style.borderColor = 'green' 
          object.style.borderWidth = '1px'
        }
				resolve(response)
			}
			else {
				object && (object.style.borderColor = 'orange')
        reject(response)
			}
		})
		.catch((error) => {
			//console.log("Error", error, data)
			//reject(error)			
		})
	})
}

const Delay = ms => new Promise(res => setTimeout(res, ms))

const Cookie = (key) => {
  const cookies = decodeURIComponent(document.cookie).split(';')
  cookies.forEach(c => {
    c = c.trim(); //console.log('cookie= ',c)
    if (c.indexOf(`${key}=`) === 0) {
      return c.substring(key.length+1, c.length) //; alert(`${key}= ${c} => ${value}`)
    }
  })
}

const IsExists = async (url, Message=null) => { 
  try { 
    const response = await fetch(url, { method: 'HEAD' }); 
    if (response.status === 200) { 
      return true;
    } 
    else { 
      Message && Message('File does not exist ?'); 
    } 
  } 
  catch (error) { 
    Message && Message(url+" "+error+"?")
  } 
}

export default Api
export {Read, Update, Fetch, Cookie, Delay, IsExists}
